{
  "onboarding.cta.complete": "Siirry palveluun",
  "onboarding.cta.continue": "Jatka",
  "onboarding.notifications.disclosure": "Ilmoitukset eivät ole vielä käytössä tässä demoversiossa.",
  "onboarding.notifications.toggle.messages": "Salli viestit",
  "onboarding.notifications.toggle.system": "Salli ilmoitukset",
  "onboarding.progress.ariaLabel": "Onboarding-eteneminen",
  "onboarding.skip": "Ohita",
  "onboarding.step.lakikaveri.body": "Kun työelämässä tulee vastaan kimurantti työoikeuteen tai palkkaan liittyvä kysymys, voit kääntyä Lakikaverin puoleen.",
  "onboarding.step.lakikaveri.title": "Lakikaveri apunasi",
  "onboarding.step.notifications.body": "Saat tiedon mm. palveluun saapuneista viesteistä. Voit hallita kaikkia viestintäasetuksia omista tiedoista. Lisääthän Oma palvelun myös kotinäytöllesi.",
  "onboarding.step.notifications.title": "Salli ilmoitukset",
  "onboarding.step.training.body": "Oma palvelusta saat koulutukset ja valmennukset veloituksetta käyttöösi. Palvelusta löydät myös rahanarvoisia etuja vapaa-aikaan.",
  "onboarding.step.training.title": "Koulutuksia ja etuja",
  "onboarding.step.welcome.body": "Palvelun kautta voit mm. ottaa yhteyttä, löydät monipuolisia koulutuksia ja etuja vapaa-ajalle.",
  "onboarding.step.welcome.title": "Oma palvelu käytössäsi"
}
